
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12.0001 22C13.1001 22 14.0001 21.1 14.0001 20H10.0001C10.0001 21.1 10.8901 22 12.0001 22ZM19.2901 17.29L18.0001 16V11C18.0001 7.93 16.3601 5.36 13.5001 4.68V4C13.5001 3.17 12.8301 2.5 12.0001 2.5C11.1701 2.5 10.5001 3.17 10.5001 4V4.68C7.63005 5.36 6.00005 7.92 6.00005 11V16L4.71005 17.29C4.08005 17.92 4.52005 19 5.41005 19H18.5801C19.4801 19 19.9201 17.92 19.2901 17.29ZM14.5001 9.33C14.5001 9.64 14.3901 9.93 14.2001 10.17L11.7001 13.2H13.6001C14.1001 13.2 14.5001 13.6 14.5001 14.1C14.5001 14.6 14.1001 15 13.6001 15H10.8201C10.0901 15 9.50005 14.41 9.50005 13.68V13.67C9.50005 13.36 9.61005 13.07 9.80005 12.83L12.3001 9.8H10.4001C9.90005 9.8 9.50005 9.4 9.50005 8.9C9.50005 8.4 9.90005 8 10.4001 8H13.1801C13.9101 8 14.5001 8.59 14.5001 9.33Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-notifications-paused`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNotificationsPaused

    ```js
    <b-new-b-icon-notifications-paused />
    ```
</docs>


